<template>
  <div class="h-dialogContainer">
    <form id='QuickExportDialog'>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.measureCycle')}}</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-dropdownlist id='timeCycleOfQuick' :dataSource='dataSourceOfCycle' :fields='fieldsOfCycle' v-model="paramsOfQuickExport.meterTimePeriod" placeholder='Select a cycle'></ejs-dropdownlist>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
          <ejs-radiobutton :label='$t("Pm.today")' name="timeOfQuickExport" value="0" :checked="true" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
          <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeOfQuickExport" value="1" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
          <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeOfQuickExport" value="2" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
          <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeOfQuickExport" value="3" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
          <ejs-radiobutton :label='$t("Pm.specified")' name="timeOfQuickExport" value="4" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
          <ejs-datetimepicker :change='validateOfQuickExportDialog' :locale='locale' name='startTimeOfQuickExport' :format='dateFormat' :enabled='startTimeEnabled' v-model='paramsOfQuickExport.meterBegTime'></ejs-datetimepicker>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
          <ejs-datetimepicker :change='validateOfQuickExportDialog' :locale='locale' name='endTimeOfQuickExport' :max='maxDateOfQuickEndTime' :format='dateFormat' :enabled='endTimeEnabled' v-model='paramsOfQuickExport.meterEndTime'></ejs-datetimepicker>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import DateUtil from '../../Util/DateUtil';

export default {
  name: 'QuickExportDialog',
  props: [
    'timeCycles'
  ],
  components: {
  },
  data() {
    return {
      maxDateOfQuickEndTime: new Date(2100, 11, 31),
      dataSourceOfCycle: [{}],
      fieldsOfCycle: {
        value: 'value',
        text: 'text'
      },
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      startTimeEnabled: false,
      endTimeEnabled: false,
      paramsOfQuickExport: {
        meterTimePeriod: 2,
        meterBegTime: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        meterEndTime: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`)
      },
      formObjOfQuickExportDialog: '',
      optionsOfQuickExportDialogValidation: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          startTimeOfQuickExport: {
            required: [true, `${this.$t('Pm.begTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.begTimeFormatError')}`]
          },
          endTimeOfQuickExport: {
            required: [true, `${this.$t('Pm.endTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.endTimeFormatError')}`]
          }
        }
      },
      locale: localStorage.getItem('locale')
    };
  },
  methods: {
    rangeRadioChangeOfCycle(args) {
      switch (args.value) {
        case '0':
          this.setTodayBeginTime();
          this.setTodayEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          break;
        case '1':
          this.setYesterdayBeginTime();
          this.setYesterdayEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          break;
        case '2':
          this.setCurrentWeekBeginTime();
          this.setCurrentWeekEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          break;
        case '3':
          this.setLastWeekBeginTime();
          this.setLastWeekEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          break;
        case '4':
          this.paramsOfQuickExport.meterBegTime = '';
          this.paramsOfQuickExport.meterEndTime = '';
          this.startTimeEnabled = true;
          this.endTimeEnabled = true;
          break;
        default:
      }
    },
    setTodayBeginTime() {
      this.paramsOfQuickExport.meterBegTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
    },
    setTodayEndTime() {
      this.paramsOfQuickExport.meterEndTime = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
    },
    setYesterdayBeginTime() {
      this.paramsOfQuickExport.meterBegTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
    },
    setYesterdayEndTime() {
      this.paramsOfQuickExport.meterEndTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
    },
    setCurrentWeekBeginTime() {
      this.paramsOfQuickExport.meterBegTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
    },
    setCurrentWeekEndTime() {
      this.paramsOfQuickExport.meterEndTime = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
    },
    setLastWeekBeginTime() {
      this.paramsOfQuickExport.meterBegTime = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
    },
    setLastWeekEndTime() {
      this.paramsOfQuickExport.meterEndTime = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
    },

    // 执行表单校验
    validateOfQuickExportDialog() {
      const formStatus = this.formObjOfQuickExportDialog.validate();
      if (!formStatus) {
        return false;
      }
      return true;
    },

    // 绑定表单校验
    bindValidateOfQuickDialog() {
      this.formObjOfQuickExportDialog = new FormValidator('#QuickExportDialog', this.optionsOfQuickExportDialogValidation);
    },
  },
  mounted() {
    this.setTodayBeginTime();
    this.setTodayEndTime();
    this.startTimeEnabled = false;
    this.endTimeEnabled = false;
    this.bindValidateOfQuickDialog();
  },
  watch: {
    timeCycles(timeCycles) {
      this.dataSourceOfCycle = timeCycles;
    }
  }
};
</script>

<style>

</style>
